import { render, staticRenderFns } from "./DefaultContent-ComingSoon.vue?vue&type=template&id=1e6d035f&"
import script from "./DefaultContent-ComingSoon.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-ComingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports